import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BaseView from "../BaseView";
import AdminViewModel from "../../view-model/admin/AdminViewModel";
import NavbarViewModel from "../../view-model/navbar/NavbarViewModel";
import User from "../../../domain/models/admin/User";
import NavbarComponent from "../navbar/NavbarComponent";
import LoadingComponent from "../../../util/component/LoadingComponent";
import { Toast } from "react-bootstrap";
interface Props {
  adminViewModel: AdminViewModel;
  navbarViewModel: NavbarViewModel;
}

interface State {
  userSearchQuery: string;
  isUserSearching: boolean;
  foundedUser: User | undefined;
  userSearchError: string;
  isUserSearchQueryError: boolean;

  newUserNameQuery: string;
  isNewUserNameError: boolean;
  newUserEmailQuery: string;
  isNewUserEmailQueryError: boolean;
  newUserPasswordQuery: string;
  isNewUserPasswordError: boolean;
  isUserCreating: boolean;
  userCreationError: string;

  isUserDeleting: boolean;
  userDeletionError: string;

  isShowUserHasBeenAdded: boolean;
  isShowUserHasBeenDeleted: boolean;
}

export default class AdminComponent extends React.Component<Props, State> implements BaseView {
  private adminViewModel: AdminViewModel;

  public constructor(props: Props) {
    super(props);
    this.adminViewModel = props.adminViewModel;

    this.state = {
      userSearchQuery: this.adminViewModel.userSearchQuery,
      isUserSearching: this.adminViewModel.isUserSearching,
      foundedUser: this.adminViewModel.foundedUser,
      userSearchError: this.adminViewModel.userSearchError,
      isUserSearchQueryError: this.adminViewModel.isUserSearchQueryError,

      newUserNameQuery: this.adminViewModel.newUserNameQuery,
      isNewUserNameError: this.adminViewModel.isNewUserEmailQueryError,
      newUserEmailQuery: this.adminViewModel.newUserEmailQuery,
      isNewUserEmailQueryError: this.adminViewModel.isNewUserEmailQueryError,
      newUserPasswordQuery: this.adminViewModel.newUserPasswordQuery,
      isNewUserPasswordError: this.adminViewModel.isNewUserPasswordError,
      isUserCreating: this.adminViewModel.isUserCreating,
      userCreationError: this.adminViewModel.userCreationError,

      isUserDeleting: this.adminViewModel.isUserDeleting,
      userDeletionError: this.adminViewModel.userDeletionError,

      isShowUserHasBeenAdded: this.adminViewModel.isShowUserHasBeenAdded,
      isShowUserHasBeenDeleted: this.adminViewModel.isShowUserHasBeenDeleted,
    };
  }

  public componentDidMount = (): void => {
    this.adminViewModel.attachView(this);
  };

  public componentWillUnmount = (): void => {
    this.adminViewModel.detachView(this);
  };

  public onViewModelChanged = (): void => {
    this.setState({
      userSearchQuery: this.adminViewModel.userSearchQuery,
      isUserSearching: this.adminViewModel.isUserSearching,
      foundedUser: this.adminViewModel.foundedUser,
      userSearchError: this.adminViewModel.userSearchError,
      isUserSearchQueryError: this.adminViewModel.isUserSearchQueryError,

      newUserNameQuery: this.adminViewModel.newUserNameQuery,
      isNewUserNameError: this.adminViewModel.isNewUserNameError,
      newUserEmailQuery: this.adminViewModel.newUserEmailQuery,
      isNewUserEmailQueryError: this.adminViewModel.isNewUserEmailQueryError,
      newUserPasswordQuery: this.adminViewModel.newUserPasswordQuery,
      isNewUserPasswordError: this.adminViewModel.isNewUserPasswordError,
      isUserCreating: this.adminViewModel.isUserCreating,
      userCreationError: this.adminViewModel.userCreationError,

      isUserDeleting: this.adminViewModel.isUserDeleting,
      userDeletionError: this.adminViewModel.userDeletionError,

      isShowUserHasBeenAdded: this.adminViewModel.isShowUserHasBeenAdded,
      isShowUserHasBeenDeleted: this.adminViewModel.isShowUserHasBeenDeleted,
    });
  };

  public render = (): JSX.Element => {
    const {
      userSearchQuery,
      isUserSearching,
      foundedUser,
      userSearchError,
      isUserSearchQueryError,

      newUserNameQuery,
      isNewUserNameError,
      newUserEmailQuery,
      isNewUserEmailQueryError,
      newUserPasswordQuery,
      isNewUserPasswordError,
      isUserCreating,
      userCreationError,

      isUserDeleting,
      userDeletionError,

      isShowUserHasBeenAdded,
      isShowUserHasBeenDeleted,
    } = this.state;

    return (
      <>
        <NavbarComponent key="admin-navbar" adminNavbarViewModel={this.props.navbarViewModel} />

        <div className="container-fluid">
          <div className="row justify-content-center mt-5 pt-5">
            <h5 className="font-weight-bold mt-3">New user registration</h5>
          </div>

          <div className="row justify-content-center mt-4">
            <div className="col-8 col-md-6 col-lg-4 col-xl-3">
              <div className="row">
                <input
                  type="text"
                  placeholder="Enter user name"
                  className={`form-control ${isNewUserNameError ? "error-border" : ""}`}
                  value={newUserNameQuery}
                  onChange={(e): void => this.adminViewModel.onNewUserNameQueryChanged(e.target.value)}
                  disabled={isUserCreating}
                />
              </div>

              <div className="row mt-2">
                <input
                  type="text"
                  placeholder="Enter user email"
                  className={`form-control ${isNewUserEmailQueryError ? "error-border" : ""}`}
                  value={newUserEmailQuery}
                  onChange={(e): void => this.adminViewModel.onNewUserEmailChanged(e.target.value)}
                  disabled={isUserCreating}
                />
              </div>

              <div className="row mt-2">
                <input
                  type="password"
                  placeholder="Password"
                  className={`form-control ${isNewUserPasswordError ? "error-border" : ""}`}
                  value={newUserPasswordQuery}
                  onChange={(e): void => this.adminViewModel.onNewUserPasswordChanged(e.target.value)}
                  disabled={isUserCreating}
                />
              </div>

              <div className="row mt-2 justify-content-center">
                <div className="col">
                  <div className="row">
                    <button
                      type="button"
                      className="btn btn-outline-success w-100 btn-generate-password"
                      style={{ marginRight: "2px" }}
                      onClick={(): void => this.adminViewModel.onGenerateNewPassword()}
                      disabled={isUserCreating}
                    >
                      Create password
                    </button>
                  </div>
                </div>

                <div className="col">
                  <div className="row">
                    <button
                      type="button"
                      className="btn btn-success w-100"
                      style={{ marginLeft: "2px" }}
                      onClick={(): void => this.adminViewModel.onCreateUser()}
                      disabled={isUserCreating}
                    >
                      {isUserCreating ? <LoadingComponent size="xs" color="light" /> : "Add user"}
                    </button>
                  </div>
                </div>
              </div>

              {isNewUserNameError && (
                <div className="row mt-3 justify-content-center text-center">
                  <span className="text-danger" style={{ maxWidth: "280px" }}>
                    Name is empty
                  </span>
                </div>
              )}

              {isNewUserEmailQueryError && (
                <div className="row mt-3 justify-content-center text-center">
                  <span className="text-danger" style={{ maxWidth: "280px" }}>
                    Email is not valid
                  </span>
                </div>
              )}

              {isNewUserPasswordError && (
                <div className="row mt-3 justify-content-center text-center">
                  <span className="text-danger" style={{ maxWidth: "280px" }}>
                    Password is empty
                  </span>
                </div>
              )}

              {userCreationError && !isNewUserPasswordError && !isNewUserEmailQueryError && !isNewUserNameError && (
                <div className="row mt-3 justify-content-center text-center">
                  <span className="text-danger" style={{ maxWidth: "280px" }}>
                    {userCreationError}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="row justify-content-center mt-5">
            <h5 className="font-weight-bold mt-3">Search for users</h5>
          </div>

          <div className="row justify-content-center mt-4">
            <div className="col-8 col-md-6 col-lg-4 col-xl-3">
              <div className="row">
                <div className="flex-grow-1">
                  <input
                    type="text"
                    placeholder="Enter searching email"
                    className={`form-control ${isUserSearchQueryError ? "error-border" : ""}`}
                    value={userSearchQuery}
                    onChange={(e): void => this.adminViewModel.onUserSearchQueryChanged(e.target.value)}
                    disabled={isUserSearching}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-outline-success ml-1"
                  style={{ width: "42px" }}
                  onClick={(): void => this.adminViewModel.onSearchUser()}
                >
                  {isUserSearching ? <LoadingComponent color="success" size="xs" /> : <FontAwesomeIcon icon="search" />}
                </button>
              </div>

              {userSearchError && (
                <div className="row mt-3 justify-content-center text-center">
                  <span className="text-danger" style={{ fontSize: "14px", maxWidth: "280px" }}>
                    {userSearchError}
                  </span>
                </div>
              )}

              {foundedUser ? (
                <>
                  {!userSearchError && (
                    <div className="row mt-3 justify-content-center text-center">
                      <span className="text-secondary" style={{ fontSize: "14px", maxWidth: "280px" }}>
                        Search results
                      </span>
                    </div>
                  )}

                  <div className="row mt-2">
                    <div className="flex-grow-1">
                      <input
                        type="text"
                        value={`${foundedUser.username} (${foundedUser.email})`}
                        className="form-control"
                        disabled
                      />
                    </div>

                    <button
                      type="button"
                      className="btn btn-outline-danger ml-1"
                      style={{ width: "42px" }}
                      onClick={(): void => this.adminViewModel.onDeleteUser(foundedUser.email)}
                      disabled={isUserDeleting}
                    >
                      {isUserSearching ? (
                        <LoadingComponent color="danger" size="xs" />
                      ) : (
                        <FontAwesomeIcon icon="times" />
                      )}
                    </button>
                  </div>

                  {userDeletionError && (
                    <div className="row mt-3 justify-content-center text-center">
                      <span className="text-danger" style={{ fontSize: "14px", maxWidth: "280px" }}>
                        {userDeletionError}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {!userSearchError && (
                    <div className="row mt-3 justify-content-center text-center">
                      <span className="text-secondary" style={{ fontSize: "14px", maxWidth: "280px" }}>
                        No users have been found
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        <div style={{ height: "50px" }} />

        <div style={{ position: "fixed", bottom: "30px", right: "30px" }}>
          <Toast
            show={isShowUserHasBeenAdded}
            onClose={(): void => this.adminViewModel.onCloseUserHasBeenAdded()}
            delay={3000}
            autohide
            className="toast-success bg-success text-white"
          >
            <Toast.Body>User has been added successfully</Toast.Body>
          </Toast>

          <Toast
            show={isShowUserHasBeenDeleted}
            onClose={(): void => this.adminViewModel.onCloseUserHasBeenDeleted()}
            delay={3000}
            autohide
            className="toast-danger bg-danger text-white"
          >
            <Toast.Body>User has been deleted successfully</Toast.Body>
          </Toast>
        </div>
      </>
    );
  };
}
